// extracted by mini-css-extract-plugin
module.exports = {"poweredByWrapper":"style_poweredByWrapper__2dXeJ","brandName":"style_brandName__1GpDQ","brandLink":"style_brandLink__P6G0-"};